<template>
    <div class="detailNav">
        <ul>
            <li class="titleItem" :class="{itemActive:index==active}" v-for="(item,index) in list" :key="index" @click="handleClick(item,index)">{{item.title}}</li>
            
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'detailNav',
        data() {
            return {
                active:0,
                item:{}
            }
        },
        
        props:{
            list:{
                type:Array,
                default(){
                    return []
                }
            },
            isHtml:{
                type:Boolean,
                default:true
            },
            
            
        },
        methods:{
            handleClick(item,index){
                this.active=index
                this.item=item
                this.$emit('change',index)
            },
            setActive(index){
                this.active=index
            },
            getItem(){
                return this.item
            },
            
        },
        created(){
           
        }
    }
</script>

<style lang="scss" scoped>
    .titleItem{
        // width: 100%;
        height:40px ;
        line-height: 40px;
        font-size:14px;
        
        font-weight:400;
        color:#2930f2;
        cursor: pointer;
        padding-left:15px;
    }
    .itemActive{
        background:#2930f2;
        color:#fff;
        position: relative;
    }
    .itemActive::after{
        content:"\e6e0";
        font-family:element-icons!important;
        position: absolute;
        right: 24px;
        top:0px;
    }
</style>